import React from 'react'

import {FiClock} from 'react-icons/fi'
import {FiMapPin} from 'react-icons/fi'
import {FiPhoneCall} from 'react-icons/fi'
import {AiOutlineMail} from 'react-icons/ai'

import './Contact.css'
import FadeIn from 'react-fade-in'

const Contact: React.FC = () => {

  return (

    // <div className=''>
      <FadeIn className='container	 '>
        <div className='bg-white  shadow-sm  mx-auto p-20   contact'>
          <div className='row flex-row-reverse'>
            <div className='col-xl-12 '>
              <div>
                <h1 className=' text-teal-800 md:text-3xl lg:text-2xl xl:text-3xl	text-center	'>راه های ارتباطی شرکت سهامی مهر ایرانیان</h1>
                <div className='row flex-row-reverse mt-16'>
                  <div className='col-md-6  '>
                    <div className='text-right'>
                      <FiClock size='40px' className='text-blue-800' />
                      <h5 className='mt-4 text-xl font-bold	'> :ساعت پاسخگویی</h5>
                      <div className='flex justify-end '>
                        <span className='text-lg tracking-wide	text-zinc-700	mt-2		'>
                          ساعته از طریق تیکت در خدمت شما هستیم
                        </span>
                        <span className='text-lg tracking-wider text-zinc-700	mt-2	'> 24 </span>
                      </div>
                    </div>

                    <div className='text-right md:mt-16 lg:mt-0 xl:mt-16'>
                      <div className='mt-10 mb-8 sm:mb-0'>
                        <FiPhoneCall size='40px' className='text-blue-800' />
                        <h5 className='mt-4 text-xl font-bold	'>: شماره تماس </h5>
                        <div className='flex justify-end '>
                          <span className='text-lg tracking-wider text-zinc-700	mt-2	'>02153457000</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='text-right'>
                      <FiMapPin size='40px' className='text-blue-800' />
                      <h5 className='mt-4 text-xl font-bold	'> :آدرس</h5>
                      <div className='flex justify-end '>
                        <span className='text-lg tracking-wide	text-zinc-700	 mt-2		'>
                          شهر پرند- بلوار شهید قاسم سلیمانی- بیمارستان مهر ایرانیان پرند
                        </span>
                      </div>
                    </div>

                    <div className='mt-10 mb-16 sm:mb-0 text-right'>
                      <AiOutlineMail size='40px' className='text-blue-800' />
                      <h5 className='mt-4 mt-2 text-xl font-bold	'> ایمیل </h5>
                      <div className='flex justify-end '>
                        <span className='text-lg tracking-wider text-zinc-700 mt-2		'>
                          mehraracto@gmail.com
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

              {/* <div className='col-xl-4 suggestion'>
                <div className='text-right 	'>
                  <h1 className="text-teal-800 md:text-3xl lg:text-2xl xl:text-3xl		">پیشنهادات شما</h1>
                </div>
                <div className="text-right md:mt-8 xl:mt-24">
                  <div className='mt-8 lg:mt-0	'>
                    <input type='text' placeholder='موضوع' />
                  </div>

                  <div className='mt-8'>
                    <textarea
                      name='comment'
                      className='text-right textarea'
                      rows={4}
                      cols={50}
                      placeholder='نظر'
                    ></textarea>
                  </div>

                </div>
              </div> */}
          </div>
        </div>
      </FadeIn>
    // </div>
  )
}

export {Contact}
